import { defineMessages } from "react-intl";

export default defineMessages({
  serviceNotIncludedInTheSubscriptionPrice: {
    id: "subscribe.serviceNotIncludedInTheSubscriptionPrice",
    defaultMessage:
      "Task payment is not included in the formula. It will be paid after the service trough <bold>the platform</bold>.",
  },
});
